import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductPage from "@/pages/ProductPage";
import About from "@/pages/About";
import Faqs from "@/pages/Faqs";
import Contact from "@/pages/Contact";
import WellnessGuide from "@/pages/WellnessGuide";
import Article from "@/pages/Article";
import LegalPage from "@/pages/LegalPage";
import { SubscriptionConfirm, Unsubscribe, NotFound } from "@/pages/Utility";
import { PRODUCTS } from "@/data/products";
import "@/App.css";

// Admin is code-split so public visitors never download CRM code.
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));

const AdminFallback = () => <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Loading…</div>;

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          {PRODUCTS.map((p) => (
            <Route key={p.slug} path={p.path} element={<ProductPage slug={p.slug} />} />
          ))}
          <Route path="/about" element={<About />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/wellness-guide" element={<WellnessGuide />} />
          <Route path="/wellness-guide/:slug" element={<Article />} />
          <Route path="/privacy-policy" element={<LegalPage page="privacy-policy" />} />
          <Route path="/terms" element={<LegalPage page="terms" />} />
          <Route path="/delivery-returns" element={<LegalPage page="delivery-returns" />} />
          <Route path="/health-disclaimer" element={<LegalPage page="health-disclaimer" />} />
          <Route path="/subscription/confirm" element={<SubscriptionConfirm />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path="/admin/login"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminLogin />
            </Suspense>
          }
        />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminDashboard />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
